export default __webpack_public_path__ + "static/SharpGroteskSmBold20-Regular-44a9aefa6051529036a205527929002d.woff";